var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.89 14.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.61,6.13c1.69-.03,3.04-1.43,3.01-3.12C18.59,1.32,17.19-.03,15.5,0c-1.67.03-3.01,1.39-3.01,3.07.02,1.71,1.41,3.08,3.12,3.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28,6.13c1.69-.03,3.04-1.43,3.01-3.12C10.27,1.32,8.87-.03,7.18,0c-1.67.03-3.01,1.39-3.01,3.07.02,1.71,1.41,3.08,3.12,3.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28,8.38c-2.45,0-7.28,1.17-7.28,3.58v2.76h14.72v-2.76c0-2.4-4.99-3.58-7.43-3.58h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.61,8.94c-.3,0-.6.01-.89.05,1.09.57,1.74,1.74,1.63,2.96v2.76h6.54v-2.76c0-2.4-4.84-3.01-7.28-3.01Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack08);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-08.140e60689922c7eed45d5a589d63fee7.svg";
export { ForwardRef as ReactComponent };